// AccountSection.tsx — Settings → Account Settings, the card dashboard from the
// owner's account_settings_v2 concept (1.27.70).
//
// Every card is real: each control either does what it says or carries a
// "Coming soon" chip. Owner rulings 2026-09-30 decide what is left off
// (passkeys, a per-device session list, deactivation, muted words, sensitive
// content). Editing the profile itself happens on /settings/profile.
import { useSession } from '@/hooks';
import { DashGrid, DashScope } from '../dashboard/dashStyles';
import { InviteLinkCard } from '../InviteLinkCard';
import { ProfileOverviewCard } from './account/ProfileOverviewCard';
import { PremiumCard } from './account/PremiumCard';
import { SecurityCard, SessionsCard } from './account/SecurityCards';
import { EmailCard } from './account/EmailCard';
import { PrivacySafetyCard } from './account/PrivacySafetyCard';
import { ConnectedCard, DangerZoneCard, DataStorageCard } from './account/DataCards';

export function AccountSection() {
  const { currentUser, isPremium } = useSession();
  if (!currentUser) return null; // route already guards auth; defensive

  return (
    <DashScope>
      <DashGrid>
        <ProfileOverviewCard user={currentUser} />
        <PremiumCard isPremium={isPremium} />
        <SecurityCard user={currentUser} />
        <EmailCard user={currentUser} />
        <PrivacySafetyCard user={currentUser} />
        <SessionsCard />
        <InviteLinkCard />
        <DataStorageCard />
        <ConnectedCard />
        <DangerZoneCard />
      </DashGrid>
    </DashScope>
  );
}
